import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"

const state = {
  fe_locale: "no"
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
